<template>
  <v-app light>
    <router-view></router-view>
    <vue-snotify></vue-snotify>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        fixed: false,
        items: [{
          icon: 'bubble_chart',
          title: 'Inspire'
        }],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'NetPlus Invoice'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue